import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Play } from "lucide-react";
import { TYPE_LABEL } from "@/lib/games";

export const GameCard = ({ game, index }) => (
  <motion.div initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: (index % 2) * 0.12, duration: 0.6 }}
    whileHover={{ rotateX: 4, rotateY: index % 2 ? -4 : 4, y: -6 }} style={{ transformPerspective: 1000 }}
    className="group relative rounded-2xl sm:rounded-3xl overflow-hidden border border-[#D4AF37]/30 bg-[#111] shadow-[0_20px_60px_rgba(0,0,0,0.6)]" data-testid={`game-card-${game.id}`}>
    <Link to={`/game/${game.id}`} className="block relative aspect-[16/10] overflow-hidden" data-testid={`game-image-link-${game.id}`}>
      <img src={game.image} alt={game.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-[#0a0a0a]/10 to-transparent" />
      <span className="absolute top-2 left-2 sm:top-4 sm:left-4 rounded-full bg-[#c4112f] px-2 sm:px-3 py-1 text-[9px] sm:text-[10px] font-bold uppercase tracking-[0.2em]">{TYPE_LABEL[game.type]}</span>
      {game.live && (
        <span className="absolute top-2 right-2 sm:top-4 sm:right-4 flex items-center gap-1.5 rounded-full bg-black/70 backdrop-blur px-2 sm:px-3 py-1 text-[9px] sm:text-[10px] font-bold uppercase tracking-[0.2em]" data-testid={`live-badge-${game.id}`}>
          <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" /> Canlı
        </span>
      )}
      {game.isNew && (
        <span className="absolute top-2 right-2 sm:top-4 sm:right-4 rounded-full bg-emerald-500 text-black px-2 sm:px-3 py-1 text-[9px] sm:text-[10px] font-bold uppercase tracking-[0.2em]" data-testid={`new-badge-${game.id}`}>Yeni</span>
      )}
      {game.hot && (
        <span className="absolute top-2 right-2 sm:top-4 sm:right-4 rounded-full bg-[#FFD700] text-black px-2 sm:px-3 py-1 text-[9px] sm:text-[10px] font-bold uppercase tracking-[0.2em]" data-testid={`hot-badge-${game.id}`}>10 Free Spin</span>
      )}
    </Link>
    <div className="p-3 sm:p-6 lg:p-8 flex flex-col sm:flex-row sm:items-end justify-between gap-3">
      <div className="min-w-0">
        <h3 className="font-display font-bold text-sm sm:text-2xl lg:text-3xl tracking-tight truncate">{game.name}</h3>
        <p className="text-zinc-400 mt-1 text-xs sm:text-base hidden sm:block">{game.tagline}</p>
      </div>
      <Link to={`/game/${game.id}`} className="btn-gold rounded-full px-4 sm:px-6 py-2 sm:py-3 font-display font-bold flex items-center justify-center gap-2 shrink-0 text-xs sm:text-base" data-testid={`play-btn-${game.id}`}>
        <Play size={14} fill="currentColor" /> Oyna
      </Link>
    </div>
  </motion.div>
);
